
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("1mHQU", function(module, exports) {
const $bacd8f7695bdf465$export$c4d5263a0e2e072d = {
    DUPLICATE_TITLE: 'A page with this title already exists',
    DUPLICATE_TITLE_WITHIN_EDITOR: 'Give this page a unique title to move',
    DUPLICATE_EDIT_PAGE_BLOG_TITLE: 'Cannot convert draft, a blog with this title already exists',
    DUPLICATE_VIEW_PAGE_BLOG_TITLE: 'Cannot convert page, a blog with this title already exists',
    EMPTY_TITLE: 'empty-title',
    TITLE_REQUIRED: 'title-required',
    AI_GENERATED_TITLE: 'Review your AI-generated title',
    AI_GENERATED_TITLE_FROM_PASTE: 'AI generated title from paste',
    AI_GENERATED_TITLE_ERROR: "We couldn\u2019t generate a title for you",
    INVALID_PAGE_TITLE: 'You need to include the title to update a page.',
    // this error message is returned with status 400 in fabric editor when page with duplicate title is published
    DUPLICATE_TITLE_WITH_BAD_EXCEPTION: 'com.atlassian.confluence.api.service.exceptions.api.BadRequestException: A page with this title already exists',
    OTHER_PUBLISH: 'other-publish',
    OTHER_RESTORE: 'other-restore',
    CONTENT_RECONCILIATION: 'content-reconciliation',
    TITLE_TOO_LONG: 'Title cannot be longer than 255 characters.',
    MEDIA_FAILED: "Can't publish changes",
    SYNCHRONY_WAS_NOT_CONNECTED_ERROR: 'An unexpected error occurred after connecting to editing services.',
    SYNCHRONY_WAS_NOT_INITIALIZED_ERROR: 'An unexpected error occurred when connecting to editing services.',
    SYNCHRONY_ACK_MISSING_ERROR: 'An unexpected error occurred after requesting the final editor state.',
    FOUND_INVALID_TEMPLATE_VARIABLE: 'Found multiple variables with the same name but different types',
    DUPLICATE_TITLE_TEMPLATE: 'Template title already used, please use a different name.',
    TEMPLATE_CONTENT_PARSING_FAILURE: 'template-content-parsing-failure',
    SYNCHRONY_UNEXPECTED_ERROR: 'An unexpected error occurred while requesting the final editor state.',
    PUBLISH_TIME_TOO_LONG_ERROR: 'An error occurred and it took too long to publish the page.',
    SCHEDULE_PUBLISH_ERROR: 'An error occurred when scheduling the publish.',
    CANCEL_SCHEDULE_PUBLISH_ERROR: 'An error occured when cancelling the scheduled publish.',
    SCHEDULE_PUBLISH_WITH_NO_TITLE_ERROR: 'Add a title, and you can set a date and time for publishing.',
    REVERT_CONTENT_ERROR: 'An error occurred while trying to revert the page.',
    PARENT_NOT_PUBLISHED: 'com.atlassian.confluence.api.service.exceptions.api.BadRequestException: Could not publish draft. Parent page has not been published.',
    RESTORE_CONTENT_SUCCESS: 'Page/blogpost has been reverted to last version',
    BLOGIFY_BLOGPOST_SUCCESS: 'Page converted to a blog post',
    TEMPLATE_PUBLISH_TAKING_LONG: 'Bear with us, this is taking a moment.',
    COLLAB_INIT_TIMEOUT_TAKING_TOO_LONG: 'Collab init event is taking too long',
    ERROR_MESSAGE_WITH_BAD_EXCEPTION: 'com.atlassian.confluence.api.service.exceptions.api.BadRequestException:',
    CONFLICT_DRAFT_VERSIONING: 'Draft versioning is not supported.',
    COLLAB_STATUS_ERROR: "Can't save changes.",
    TEMPLATE_INVALID_SPACEKEY_ERROR: 'Invalid spaceKeys.',
    TEMPLATE_BLANK_TITLE_ERROR: 'Template title cannot be null or empty string',
    CREATED_FROM_EXTENSION: 'Draft created from create page extension'
};
module.exports["ALLOWED_FLAG_MESSAGES"] = $bacd8f7695bdf465$export$c4d5263a0e2e072d;

});

parcelRegister("cHfGW", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $2Nwuj = parcelRequire("2Nwuj");


var $iXCQx = parcelRequire("iXCQx");


var $9wGTI = parcelRequire("9wGTI");


var $jlIaF = parcelRequire("jlIaF");


var $jhwJP = parcelRequire("jhwJP");


var $1mHQU = parcelRequire("1mHQU");

// eslint-disable-next-line check-i18n-id-prefix/i18n-id-prefix-with-package-name-defineMessages
const $d33bb643a38eaa5e$var$i18nBase = (0, $cgtv4.defineMessages)({
    duplicatePageTitleHeader: {
        id: "editor-flags.save.page.exist.content.title",
        defaultMessage: "Give your page a unique name"
    },
    duplicateLivePageTitleHeader: {
        id: "editor-flags.save.live.page.exist.content.title",
        defaultMessage: "Give your doc a unique name"
    },
    duplicatePageTitleMessage: {
        id: "editor-flags.save.page.exist.message",
        defaultMessage: "Page names have to be unique within a space. Give your page a different name to publish it."
    },
    duplicateLivePageTitleMessage: {
        id: "editor-flags.save.live.page.exist.message",
        defaultMessage: "Live docs need unique names within a space. Give your doc a different name. "
    },
    duplicateUpdatePageTitleMessage: {
        id: "editor-flags.save.update-page.exist.message",
        defaultMessage: "Page names have to be unique within a space. Give your page a different name to update it."
    },
    pageTitleInvalidTitleHeader: {
        id: "editor-flags.page.title.invalid.header",
        defaultMessage: "Invalid title - try again."
    },
    pageTitleUpdateInvalidTitleHeader: {
        id: "editor-flags.update-page.title.invalid.header",
        defaultMessage: "We can\u2019t update the page with that name."
    },
    pageTitleInvalidTitleMessage: {
        id: "editor-flags.page.title.invalid.message",
        defaultMessage: "Try another title, up to 255 characters."
    },
    pageTitleTooLongHeader: {
        id: "editor-flags.title.too.long.title",
        defaultMessage: "Your title is too long."
    },
    pageTitleTooLongMessage: {
        id: "editor-flags.title.too.long",
        defaultMessage: "The limit for titles is 255 characters."
    },
    duplicateTemplateTitleHeader: {
        id: "editor-flags.template.can.not.save.error.title.duplicate.title",
        defaultMessage: "A template with this name already exists"
    },
    duplicateTemplateTitleMessage: {
        id: "editor-flags.template.can.not.save.error.title.duplicate",
        defaultMessage: "Template names must be unique within a space. Give your template a different name to save it."
    },
    pageTooBigHeader: {
        id: "editor-flags.page.is.too.big.title",
        defaultMessage: "We can\u2019t save your content"
    },
    pageTooBigMessage: {
        id: "editor-flags.page.is.too.big",
        defaultMessage: "Pages larger than the 2MB limit are slow to load. Break your content into a couple pages and use the Include Page macro to display the content here."
    },
    templateTooBigHeader: {
        id: "editor-flags.template.is.too.big.title",
        defaultMessage: "We can\u2019t save your template"
    },
    templateTooBigMessage: {
        id: "editor-flags.template.is.too.big",
        defaultMessage: "Templates larger than the 2MB limit are slow to load. Break your content into a couple of templates."
    },
    connectionErrorHeader: {
        id: "editor-flags.offline.save.error.title",
        defaultMessage: "We\u2019re having trouble connecting right now"
    },
    connectionErrorMessage: {
        id: "editor-flags.offline.save.error",
        defaultMessage: "Give us a few seconds to reconnect, and you can resume your work."
    },
    templateConnectionParsingFailHeader: {
        id: "editor-flags.template.can.not.parse.content.title",
        defaultMessage: "We can\u2019t open this template"
    },
    templateConnectionParsingFailMessage: {
        id: "editor-flags.template.can.not.parse.content",
        defaultMessage: "This happens when a template contains broken or unsupported elements."
    },
    publishIsTakingTooLongHeader: {
        id: "editor-flags.error.delayed.publishing.title",
        defaultMessage: "We\u2019re having trouble publishing"
    },
    updateIsTakingTooLongHeader: {
        id: "editor-flags.error.delayed.updating.title",
        defaultMessage: "We\u2019re having trouble updating"
    },
    publishIsTakingTooLongMessage: {
        id: "editor-flags.error.delayed.publishing",
        defaultMessage: "We\u2019ll continue trying to publish. If it\u2019s taking too long, refresh the page and click {buttonText}."
    },
    updateIsTakingTooLongMessage: {
        id: "editor-flags.error.delayed.updating",
        defaultMessage: "We\u2019ll continue trying to update. If it\u2019s taking too long, refresh the page and click {buttonText}."
    },
    publishText: {
        id: "editor-flags.error.delayed.publishText",
        defaultMessage: "Publish"
    },
    updateText: {
        id: "editor-flags.error.delayed.updateText",
        defaultMessage: "Update"
    },
    schedulePublishErrorHeader: {
        id: "editor-flags.error.schedule.publish.title",
        defaultMessage: "We had an issue setting the schedule time"
    },
    schedulePublishErrorMessage: {
        id: "editor-flags.error.schedule.publish",
        defaultMessage: "Refresh the page and try again."
    },
    cancelScheduledPublishErrorHeader: {
        id: "editor-flags.error.cancel.scheduled.publish.title",
        defaultMessage: "We had an issue cancelling this scheduled publish"
    },
    cancelScheduledUpdateErrorHeader: {
        id: "editor-flags.error.cancel.scheduled.update.title",
        defaultMessage: "We had an issue cancelling this scheduled update"
    },
    cancelScheduledPublishErrorMessage: {
        id: "editor-flags.error.cancel.scheduled.publish",
        defaultMessage: "Refresh the page and try again."
    },
    schedulePublishNoHeaderErrorHeader: {
        id: "editor-flags.error.scheduled.publish.no-title-error.title",
        defaultMessage: "Your page needs a name"
    },
    schedulePublishNoHeaderErrorMessage: {
        id: "editor-flags.error.scheduled.publish.no-title-error",
        defaultMessage: "Add a title, and you can set a date and time for publishing."
    },
    scheduleUpdateNoHeaderErrorMessage: {
        id: "editor-flags.error.scheduled.update.no-title-error",
        defaultMessage: "Add a title, and you can set a date and time for updating."
    },
    defaultPublishErrorHeader: {
        id: "editor-flags.offline.save.error.generic.title",
        defaultMessage: "Your work is safe, but there\u2019s an issue"
    },
    defaultPublishErrorMessage: {
        id: "editor-flags.offline.save.error.generic",
        defaultMessage: "Refresh the page, and click Publish again."
    },
    defaultUpdateErrorMessage: {
        id: "editor-flags.offline.update.save.error.generic",
        defaultMessage: "Refresh the page, and click Update again."
    },
    defaultTemplateSaveErrorHeader: {
        id: "editor-flags.template.save.error.generic.title",
        defaultMessage: "There\u2019s an issue saving your template"
    },
    defaultTemplateSaveErrorMessage: {
        id: "editor-flags.template.save.error.generic.message",
        defaultMessage: "Try clicking Save again."
    },
    duplicateBlogTitleFromEditPageErrorHeader: {
        id: "editor-flags.error.edit-page.duplicate-blog-title-error.title",
        defaultMessage: "A blog with this name already exists"
    },
    duplicateBlogTitleFromEditPageErrorMessage: {
        id: "editor-flags.error.edit-page.duplicate-blog-title-error.message",
        defaultMessage: "Rename the page before publishing it as a blog."
    },
    duplicateUpdateBlogTitleFromEditPageErrorMessage: {
        id: "editor-flags.error.edit-page.update.duplicate-blog-title-error.message",
        defaultMessage: "Rename the page before updating it as a blog."
    },
    duplicateBlogTitleFromViewPageErrorHeader: {
        id: "editor-flags.error.view-page.duplicate-blog-title-error.title",
        defaultMessage: "A blog with this name already exists"
    },
    duplicateBlogTitleFromViewPageErrorMessage: {
        id: "editor-flags.error.view-page.duplicate-blog-title-error.message",
        defaultMessage: "Rename the page before converting it to a blog."
    },
    noAuthorizeMessage: {
        id: "editor-flags.error.no.authorize.message",
        defaultMessage: "Your session has expired. You\u2019ll need to log in again or switch to another account to keep working. {loginLink}"
    },
    loginLink: {
        id: "editor-flags.error.login.link",
        defaultMessage: "Log in or switch to another account"
    },
    noAccessMessage: {
        id: "editor-flags.error.no.access.message",
        defaultMessage: "Your session may have expired. You\u2019ll need to log in again or switch to another account to keep working. {loginLink}"
    },
    pageIsTrashedMessage: {
        id: "editor-flags.error.page.trashed.message",
        defaultMessage: "Copy your content, then add it to a new page or <link>restore this page from the trash</link> and try again."
    },
    livePageIsTrashedMessage: {
        id: "editor-flags.error.live.page.trashed.message",
        defaultMessage: "Copy your content, then add it to a new doc or <link>restore this doc from the trash</link> and try again."
    },
    pageIsTrashedMessageLink: {
        id: "editor-flags.error.page.trashed.message.link",
        defaultMessage: "Restore this content from the trash"
    },
    invalidTemplateVariableMessage: {
        id: "editor-flags.error.invalid.template.variable.message",
        defaultMessage: "Multiple template variables which have the same name \u201C{variableNames}\u201D but different parameters."
    },
    cantRevertPageTitle: {
        id: "editor.discard-to-published.error.title",
        defaultMessage: "Can\u2019t revert to last published version"
    },
    cantRevertPageMessage: {
        id: "editor.discard-to-published.error.message",
        defaultMessage: "We can\u2019t get the last published version of the page at the moment. Give it a few moments then try discarding the draft again."
    },
    parentNotPublishedHeader: {
        id: "editor-flags.error.edit-page.parent-not-published.title",
        defaultMessage: "This draft can\u2019t be published"
    },
    parentNotPublishedMessage: {
        id: "editor-flags.error.edit-page.parent-not-published.message",
        defaultMessage: "A published page can\u2019t exist under a page in the draft state. Publish the <link>parent page</link> first, then publish this page."
    },
    titleRequiredHeader: {
        id: "editor-flags.page.title.required.header",
        defaultMessage: "Title required"
    },
    titleRequiredMessage: {
        id: "editor-flags.page.title.required.message",
        defaultMessage: "Add a title before publishing."
    },
    titleRequiredUpdateMessage: {
        id: "editor-flags.update.page.title.required.update.message",
        defaultMessage: "Add a title before updating."
    },
    titleGeneratedAI: {
        id: "editor-flags.generate.ai.title",
        defaultMessage: "Review your AI-generated title"
    },
    titleGeneratedAIDescription: {
        id: "editor-flags.generate.ai.description",
        defaultMessage: "Rovo is generating a title for this page, as a title is required to publish. Select <bold>Accept</bold> to publish the page with this title or edit the title and publish manually. <Link>Content quality may vary.</Link>"
    },
    titleGeneratedFromPasteAI: {
        id: "editor-flags.generate.ai.from.paste.title",
        defaultMessage: "Rovo wrote a title for you"
    },
    titleGeneratedFromPasteAIDescription: {
        id: "editor-flags.generate.ai.from.paste.description",
        defaultMessage: "It\u2019s based on the text you pasted. <Link>Uses AI. Verify results.</Link>"
    },
    titleGeneratedAIError: {
        id: "editor-flags.generate.ai.error.title",
        defaultMessage: "We couldn\u2019t generate a title for you"
    },
    titleGeneratedAIErrorDescription: {
        id: "editor-flags.generate.ai.error.description",
        defaultMessage: "Rovo was unable to generate a title for you at this time. You can add a title and publish the page manually instead. <Link>Why did this happen?</Link>"
    },
    refreshPageConflictHeader: {
        id: "editor-flags.error.conflict.refresh-page.header",
        defaultMessage: "Refresh this page in order to publish"
    },
    refreshPageUpdateConflictHeader: {
        id: "editor-flags.error.update.conflict.refresh-page.header",
        defaultMessage: "Refresh in order to update"
    },
    refreshPageConflictMessage: {
        id: "editor-flags.error.conflict.refresh-page.message",
        defaultMessage: "This version has been updated by another user. Refresh the page in order to sync and publish your changes."
    },
    refreshUpdatePageConflictMessage: {
        id: "editor-flags.error.update.conflict.refresh-page.message",
        defaultMessage: "This version has been updated by another user. Refresh now in order to sync your changes."
    },
    draftConflictHeader: {
        id: "editor-flags.error.conflict.draft.header",
        defaultMessage: "Unable to publish draft"
    },
    draftConflictMessage: {
        id: "editor-flags.error.conflict.draft.message",
        defaultMessage: "Due to a server error, this draft can\u2019t be published. Copy and paste this content into a new draft in order to publish it."
    },
    duplicatePageNameWithinEditorErrorTitle: {
        id: "editor-flags.move-error.duplicate-page-name-within-editor.title",
        defaultMessage: "Give this page a unique title to move"
    },
    duplicateLivePageNameWithinEditorErrorTitle: {
        id: "editor-flags.move-error.duplicate-live-page-name-within-editor.title",
        defaultMessage: "Give this doc a unique title to move"
    },
    duplicatePageNameWithinEditorErrorDescription: {
        id: "editor-flags.move-error.duplicate-page-name-within-editor.description",
        defaultMessage: "To move this page to the {destinationSpace} space, give it a unique title and publish it first."
    },
    duplicateLivePageNameWithinEditorErrorDescription: {
        id: "editor-flags.move-error.duplicate-live-page-name-within-editor.description",
        defaultMessage: "To move this live doc to the {destinationSpace} space, give it a unique title."
    },
    duplicatePageNameWithinEditorUpdateErrorDescription: {
        id: "editor-flags.move-error.duplicate-page-name-within-editor.update.description",
        defaultMessage: "To move this page to the {destinationSpace} space, give it a unique title and update it first."
    },
    duplicateLivePageNameWithinEditorUpdateErrorDescription: {
        id: "editor-flags.move-error.duplicate-live-page-name-within-editor.update.description",
        defaultMessage: "To move this live doc to the {destinationSpace} space, give it a unique title and update it first."
    },
    collabStatusErrorTitle: {
        id: "editor-flags.collab-status-error.title",
        defaultMessage: "Can\u2019t save changes"
    },
    collabStatusErrorDescription: {
        id: "editor-flags.collab-status-error.description",
        defaultMessage: "Copy your work, then refresh, and we\u2019ll try to reconnect."
    },
    invalidSpaceKeyHeader: {
        id: "editor-flags.template.save.error.spacekey.invalid.header",
        defaultMessage: "There was an issue creating a template in this space"
    },
    invalidSpaceKeyMessage: {
        id: "editor-flags.template.save.error.spacekey.invalid.message",
        defaultMessage: "Check if the space exists and if you have admin permissions to create templates."
    },
    templateBlankTitleErrorHeader: {
        id: "editor-flags.template.can.not.save.error.title.blank.header",
        defaultMessage: "We can\u2019t save this template"
    },
    templateBlankTitleErrorMessage: {
        id: "editor-flags.template.can.not.save.error.title.blank.message",
        defaultMessage: "Templates can\u2019t have blank titles. Give your template a title to publish."
    }
});
const $d33bb643a38eaa5e$var$i18nLiveDocs = (0, $cgtv4.defineMessages)({
    pageTooBigMessage: {
        id: "editor-flags.page.is.too.big.livedocs",
        defaultMessage: "Content that is larger than the 2MB limit is slow to load. Break your content into a couple of pages or live docs and use the Include Page macro to display the content here."
    }
});
const $d33bb643a38eaa5e$var$i18n = (0, $jhwJP.mergeLiveDocI18n)($d33bb643a38eaa5e$var$i18nBase, $d33bb643a38eaa5e$var$i18nLiveDocs);
const $d33bb643a38eaa5e$var$BOLD_BUTTON_TEXT = ({ isUnpublishedDraft: isUnpublishedDraft })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.publishText : $d33bb643a38eaa5e$var$i18n.updateText));
const $d33bb643a38eaa5e$var$LOGIN_LINK = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        href: "/login?application=confluence"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $d33bb643a38eaa5e$var$i18n.loginLink)));
const $d33bb643a38eaa5e$var$TRASH_LINK = ({ spaceKey: spaceKey, text: text })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        href: `${(0, $jlIaF.CONTEXT_PATH)}/pages/viewtrash.action?key=${spaceKey}`,
        target: "_blank"
    }, text));
const $d33bb643a38eaa5e$var$PARENT_LINK = ({ parentPageId: parentPageId, text: text })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, parentPageId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        href: `${(0, $jlIaF.CONTEXT_PATH)}/pages/resumedraft.action?draftId=${parentPageId}`,
        target: "_blank"
    }, text) : text);
const $d33bb643a38eaa5e$var$i18nInitializer = (formatMessage, isLivePage)=>({
        DUPLICATE_PAGE_TITLE: (isUnpublishedDraft)=>{
            const duplicatePageTitleMessage = isLivePage && (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? $d33bb643a38eaa5e$var$i18n.duplicateLivePageTitleMessage : $d33bb643a38eaa5e$var$i18n.duplicatePageTitleMessage;
            return {
                title: isLivePage && (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? formatMessage($d33bb643a38eaa5e$var$i18n.duplicateLivePageTitleHeader) : formatMessage($d33bb643a38eaa5e$var$i18n.duplicatePageTitleHeader),
                description: formatMessage(isUnpublishedDraft ? duplicatePageTitleMessage : $d33bb643a38eaa5e$var$i18n.duplicateUpdatePageTitleMessage)
            };
        },
        TITLE_TOO_LONG: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.pageTitleTooLongHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.pageTitleTooLongMessage)
            }),
        DUPLICATE_TEMPLATE_TITLE: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.duplicateTemplateTitleHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.duplicateTemplateTitleMessage)
            }),
        PARENT_NOT_PUBLISHED: (parentPageId)=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.parentNotPublishedHeader),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                    ...$d33bb643a38eaa5e$var$i18n.parentNotPublishedMessage,
                    values: {
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d33bb643a38eaa5e$var$PARENT_LINK, {
                                parentPageId: parentPageId,
                                text: chunks
                            })
                    }
                })
            }),
        NO_AUTHORIZE: ()=>({
                title: formatMessage({
                    id: "editor.offline.save.noauthorized.title"
                }),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                    ...$d33bb643a38eaa5e$var$i18n.noAuthorizeMessage,
                    values: {
                        loginLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d33bb643a38eaa5e$var$LOGIN_LINK, null)
                    }
                })
            }),
        PAGE_CANNOT_BE_ACCESSED: ()=>({
                title: formatMessage({
                    id: "editor.page.can.not.be.accessed.title"
                }),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                    ...$d33bb643a38eaa5e$var$i18n.noAccessMessage,
                    values: {
                        loginLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d33bb643a38eaa5e$var$LOGIN_LINK, null)
                    }
                })
            }),
        PAGE_CONFLICT_REFRESH: (isUnpublishedDraft)=>({
                title: formatMessage(isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.refreshPageConflictHeader : $d33bb643a38eaa5e$var$i18n.refreshPageUpdateConflictHeader),
                description: formatMessage(isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.refreshPageConflictMessage : $d33bb643a38eaa5e$var$i18n.refreshUpdatePageConflictMessage)
            }),
        PAGE_CONFLICT_DRAFT: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.draftConflictHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.draftConflictMessage)
            }),
        PAGE_TRASHED: (spaceKey)=>({
                title: formatMessage({
                    id: "editor.page.is.trashed.title"
                }),
                description: isLivePage && (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                    ...$d33bb643a38eaa5e$var$i18n.livePageIsTrashedMessage,
                    values: {
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d33bb643a38eaa5e$var$TRASH_LINK, {
                                spaceKey: spaceKey,
                                text: chunks
                            })
                    }
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                    ...$d33bb643a38eaa5e$var$i18n.pageIsTrashedMessage,
                    values: {
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d33bb643a38eaa5e$var$TRASH_LINK, {
                                spaceKey: spaceKey,
                                text: chunks
                            })
                    }
                })
            }),
        PAGE_TOO_BIG: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.pageTooBigHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.pageTooBigMessage)
            }),
        TEMPLATE_TOO_BIG: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.templateTooBigHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.templateTooBigMessage)
            }),
        OFFLINE_ERROR: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.connectionErrorHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.connectionErrorMessage)
            }),
        TEMPLATE_CONTENT_PARSING_FAILURE: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.templateConnectionParsingFailHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.templateConnectionParsingFailMessage)
            }),
        EMPTY_TITLE: ()=>({
                title: formatMessage({
                    id: "editor.title.is.empty.title"
                }),
                description: formatMessage({
                    id: "editor.title.is.empty"
                })
            }),
        DUPLICATE_EDIT_PAGE_BLOG_TITLE: (isUnpublishedDraft)=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.duplicateBlogTitleFromEditPageErrorHeader),
                description: formatMessage(isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.duplicateBlogTitleFromEditPageErrorMessage : $d33bb643a38eaa5e$var$i18n.duplicateUpdateBlogTitleFromEditPageErrorMessage)
            }),
        DUPLICATE_VIEW_PAGE_BLOG_TITLE: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.duplicateBlogTitleFromViewPageErrorHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.duplicateBlogTitleFromViewPageErrorMessage)
            }),
        MEDIA_FAILED: ()=>({
                title: formatMessage({
                    id: "editor.cant.publish.changes"
                }),
                description: formatMessage({
                    id: "editor.files.may.be.uploading"
                })
            }),
        INVALID_TEMPLATE_VARIABLE: (errorData)=>({
                title: formatMessage({
                    id: "fabric.template.can.not.save.error.title"
                }),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                    ...$d33bb643a38eaa5e$var$i18n.invalidTemplateVariableMessage,
                    values: {
                        variableNames: errorData.i18nOptions.variableNames
                    }
                })
            }),
        DUPLICATE_PAGE_TITLE_WITHIN_EDITOR: (destinationSpace, isUnpublishedDraft)=>({
                title: formatMessage(isLivePage && (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? $d33bb643a38eaa5e$var$i18n.duplicateLivePageNameWithinEditorErrorTitle : $d33bb643a38eaa5e$var$i18n.duplicatePageNameWithinEditorErrorTitle),
                description: isLivePage && (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                    ...isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.duplicateLivePageNameWithinEditorErrorDescription : $d33bb643a38eaa5e$var$i18n.duplicateLivePageNameWithinEditorUpdateErrorDescription,
                    values: {
                        destinationSpace: destinationSpace
                    }
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                    ...isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.duplicatePageNameWithinEditorErrorDescription : $d33bb643a38eaa5e$var$i18n.duplicatePageNameWithinEditorUpdateErrorDescription,
                    values: {
                        destinationSpace: destinationSpace
                    }
                })
            }),
        RECONCILIATION_ERROR: (errorData, nextTryIn)=>{
            const title = formatMessage({
                id: "editor.content.reconciliation.error.title"
            });
            if (nextTryIn != null) return {
                title: title,
                description: (secondsLeft)=>formatMessage({
                        id: "editor.content.reconciliation.error.retrying"
                    }, {
                        0: `${secondsLeft}`
                    })
            };
            const showStagingError = false;
            const messageEnv = showStagingError ? 'staging' : 'prod';
            const i18nDescriptionMessage = {
                id: `editor.content.reconciliation.error.fatal.${messageEnv}`
            };
            const description = formatMessage(i18nDescriptionMessage);
            const details = `${formatMessage({
                id: "editor.content.reconciliation.error.details"
            })} ${errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).CONTENT_RECONCILIATION]}`;
            return {
                title: title,
                description: description,
                details: details
            };
        },
        PUBLISH_TIME_TOO_LONG_ERROR: (isUnpublishedDraft)=>({
                title: formatMessage(isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.publishIsTakingTooLongHeader : $d33bb643a38eaa5e$var$i18n.updateIsTakingTooLongHeader),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                    ...isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.publishIsTakingTooLongMessage : $d33bb643a38eaa5e$var$i18n.updateIsTakingTooLongMessage,
                    values: {
                        buttonText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d33bb643a38eaa5e$var$BOLD_BUTTON_TEXT, {
                            isUnpublishedDraft: isUnpublishedDraft
                        })
                    }
                })
            }),
        SCHEDULE_PUBLISH_ERROR: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.schedulePublishErrorHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.schedulePublishErrorMessage)
            }),
        CANCEL_SCHEDULE_PUBLISH_ERROR: (isUnpublishedDraft)=>({
                title: formatMessage(isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.cancelScheduledPublishErrorHeader : $d33bb643a38eaa5e$var$i18n.cancelScheduledUpdateErrorHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.cancelScheduledPublishErrorMessage)
            }),
        SCHEDULE_PUBLISH_WITH_NO_TITLE_ERROR: (isUnpublishedDraft)=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.schedulePublishNoHeaderErrorHeader),
                description: formatMessage(isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.schedulePublishNoHeaderErrorMessage : $d33bb643a38eaa5e$var$i18n.scheduleUpdateNoHeaderErrorMessage)
            }),
        DEFAULT_PUBLISH_ERROR: (isUnpublishedDraft)=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.defaultPublishErrorHeader),
                description: formatMessage(isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.defaultPublishErrorMessage : $d33bb643a38eaa5e$var$i18n.defaultUpdateErrorMessage)
            }),
        DEFAULT_TEMPLATE_SAVE_ERROR: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.defaultTemplateSaveErrorHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.defaultTemplateSaveErrorMessage)
            }),
        REVERT_CONTENT_ERROR: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.cantRevertPageTitle),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.cantRevertPageMessage)
            }),
        PUBLISH_CONDITION_ERROR: (errorMsg)=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.defaultPublishErrorHeader),
                description: errorMsg
            }),
        INVALID_PAGE_TITLE_ERROR: (isUnpublishedDraft)=>({
                title: formatMessage(isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.pageTitleInvalidTitleHeader : $d33bb643a38eaa5e$var$i18n.pageTitleUpdateInvalidTitleHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.pageTitleInvalidTitleMessage)
            }),
        TITLE_REQUIRED: (isUnpublishedDraft)=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.titleRequiredHeader),
                description: formatMessage(isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.titleRequiredMessage : $d33bb643a38eaa5e$var$i18n.titleRequiredUpdateMessage)
            }),
        AI_GENERATED_TITLE: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.titleGeneratedAI),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.titleGeneratedAIDescription, {
                    Link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                            target: "_blank",
                            href: "https://www.atlassian.com/trust/atlassian-intelligence",
                            appearance: "subtle"
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("u", null, chunks)),
                    bold: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                            weight: "bold"
                        }, " ", chunks, " ")
                })
            }),
        AI_GENERATED_TITLE_FROM_PASTE: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.titleGeneratedFromPasteAI),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.titleGeneratedFromPasteAIDescription, {
                    Link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                            target: "_blank",
                            href: "https://www.atlassian.com/trust/atlassian-intelligence",
                            appearance: "subtle"
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("u", null, chunks)),
                    bold: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                            weight: "bold"
                        }, " ", chunks, " ")
                })
            }),
        AI_GENERATED_TITLE_ERROR: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.titleGeneratedAIError),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.titleGeneratedAIErrorDescription, {
                    Link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                            target: "_blank",
                            href: "https://support.atlassian.com/organization-administration/docs/troubleshoot-atlassian-intelligence/",
                            appearance: "subtle"
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("u", null, chunks))
                })
            }),
        COLLAB_STATUS_ERROR: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.collabStatusErrorTitle),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.collabStatusErrorDescription)
            }),
        INVALID_SPACEKEY_ERROR: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.invalidSpaceKeyHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.invalidSpaceKeyMessage)
            }),
        TEMPLATE_BLANK_TITLE_ERROR: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.templateBlankTitleErrorHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.templateBlankTitleErrorMessage)
            })
    });
const $d33bb643a38eaa5e$export$cda5b5526dda47f7 = ({ errorData: errorData, statusCode: statusCode, spaceKey: spaceKey, parentPageId: parentPageId, nextTryIn: nextTryIn, formatMessage: formatMessage, isTemplateEditor: isTemplateEditor = false, isUnpublishedDraft: isUnpublishedDraft = true, isLivePage: isLivePage = false })=>{
    if (!errorData || !Object.keys(errorData).length) return null;
    const i18nFormatter = $d33bb643a38eaa5e$var$i18nInitializer(formatMessage, isLivePage);
    // Http errors from the content api when publishing
    if (statusCode != null) switch(statusCode){
        case 400:
            if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_TITLE] || // have to check instead of doing errorData[ALLOWED_FLAG_MESSAGES.DUPLICATE_TITLE_WITH_BAD_EXCEPTION]
            // because BE message would sometimes have extra words at the end of A page with this title already exists
            // eg com.atlassian.confluence.api.service.exceptions.api.BadRequestException: A page with this title already exists:
            // A page already exists with the title <PAGE_TITLE> in the space with key <SPACE_KEY>
            Object.keys(errorData)[0].indexOf((0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_TITLE_WITH_BAD_EXCEPTION) !== -1) return i18nFormatter.DUPLICATE_PAGE_TITLE(isUnpublishedDraft);
            else if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).INVALID_PAGE_TITLE]) return i18nFormatter.INVALID_PAGE_TITLE_ERROR(isUnpublishedDraft);
            else if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).TITLE_TOO_LONG]) return i18nFormatter.TITLE_TOO_LONG();
            else if (Object.keys(errorData)[0].indexOf((0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_TITLE_TEMPLATE) !== -1) return i18nFormatter.DUPLICATE_TEMPLATE_TITLE();
            else if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).PARENT_NOT_PUBLISHED]) return i18nFormatter.PARENT_NOT_PUBLISHED(parentPageId);
            else if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).TEMPLATE_INVALID_SPACEKEY_ERROR]) return i18nFormatter.INVALID_SPACEKEY_ERROR();
            else if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).TEMPLATE_BLANK_TITLE_ERROR]) return i18nFormatter.TEMPLATE_BLANK_TITLE_ERROR();
            else if (// BadRequestException means something wrong with the request. BE throws this exception on request validation fail
            // This BadRequestException has a message attached to it and we should use it as default message if non of above conditions are met.
            // That's why make sure this "if" block should say at last.
            // We are adding this as part of our PublishCondition implementation. Please go through: https://hello.atlassian.net/wiki/spaces/CCECO/pages/1289257589/Custom+publishing+flow
            // For any further questions please contact ecosystem-ini team.
            Object.keys(errorData)[0].indexOf((0, $1mHQU.ALLOWED_FLAG_MESSAGES).ERROR_MESSAGE_WITH_BAD_EXCEPTION) !== -1) {
                // positive look-behind "(?<=expression)" is not supported with str.match() so end up using below pattern.
                const patt = '[^com.atlassian.confluence.api.service.exceptions.api.BadRequestException:].*';
                const errorMsg = Object.keys(errorData)[0].match(patt);
                return i18nFormatter.PUBLISH_CONDITION_ERROR(errorMsg);
            }
            break;
        case 403:
            return i18nFormatter.NO_AUTHORIZE();
        case 404:
            return i18nFormatter.PAGE_CANNOT_BE_ACCESSED();
        case 409:
            if (Object.keys(errorData)[0].indexOf((0, $1mHQU.ALLOWED_FLAG_MESSAGES).CONFLICT_DRAFT_VERSIONING) !== -1) return i18nFormatter.PAGE_CONFLICT_DRAFT();
            return i18nFormatter.PAGE_CONFLICT_REFRESH(isUnpublishedDraft);
        case 410:
            if (isTemplateEditor) return i18nFormatter.DEFAULT_TEMPLATE_SAVE_ERROR();
            return i18nFormatter.PAGE_TRASHED(spaceKey);
        case 413:
            return isTemplateEditor ? i18nFormatter.TEMPLATE_TOO_BIG() : i18nFormatter.PAGE_TOO_BIG();
        case 0:
        case 500:
        case 503:
            return i18nFormatter.OFFLINE_ERROR();
    }
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).TEMPLATE_CONTENT_PARSING_FAILURE]) return i18nFormatter.TEMPLATE_CONTENT_PARSING_FAILURE();
    // editor errors triggered from within the fabric editor
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).EMPTY_TITLE]) return i18nFormatter.EMPTY_TITLE();
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_VIEW_PAGE_BLOG_TITLE]) return i18nFormatter.DUPLICATE_VIEW_PAGE_BLOG_TITLE();
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_TITLE_WITHIN_EDITOR]) return i18nFormatter.DUPLICATE_PAGE_TITLE_WITHIN_EDITOR(errorData.destinationSpace, isUnpublishedDraft);
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_EDIT_PAGE_BLOG_TITLE]) return i18nFormatter.DUPLICATE_EDIT_PAGE_BLOG_TITLE(isUnpublishedDraft);
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_TITLE_TEMPLATE]) return i18nFormatter.DUPLICATE_TEMPLATE_TITLE();
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).MEDIA_FAILED]) return i18nFormatter.MEDIA_FAILED();
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).FOUND_INVALID_TEMPLATE_VARIABLE]) return i18nFormatter.INVALID_TEMPLATE_VARIABLE(errorData);
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).CONTENT_RECONCILIATION]) return i18nFormatter.RECONCILIATION_ERROR(errorData, nextTryIn);
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).PUBLISH_TIME_TOO_LONG_ERROR]) return i18nFormatter.PUBLISH_TIME_TOO_LONG_ERROR(isUnpublishedDraft);
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).SCHEDULE_PUBLISH_ERROR]) return i18nFormatter.SCHEDULE_PUBLISH_ERROR();
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).CANCEL_SCHEDULE_PUBLISH_ERROR]) return i18nFormatter.CANCEL_SCHEDULE_PUBLISH_ERROR(isUnpublishedDraft);
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).SCHEDULE_PUBLISH_WITH_NO_TITLE_ERROR]) return i18nFormatter.SCHEDULE_PUBLISH_WITH_NO_TITLE_ERROR(isUnpublishedDraft);
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).REVERT_CONTENT_ERROR]) return i18nFormatter.REVERT_CONTENT_ERROR();
    // UX https://product-fabric.atlassian.net/browse/CEMS-2468
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).COLLAB_INIT_TIMEOUT_TAKING_TOO_LONG]) return i18nFormatter.OFFLINE_ERROR();
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).TITLE_REQUIRED]) return i18nFormatter.TITLE_REQUIRED(isUnpublishedDraft);
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).AI_GENERATED_TITLE]) return i18nFormatter.AI_GENERATED_TITLE();
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).AI_GENERATED_TITLE_FROM_PASTE]) return i18nFormatter.AI_GENERATED_TITLE_FROM_PASTE();
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).AI_GENERATED_TITLE_ERROR]) return i18nFormatter.AI_GENERATED_TITLE_ERROR();
    // Adding duplicate and invalid page errors outside of status code 400 for use with publish modal buttons (they do not send requests)
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_TITLE] || // have to check instead of doing errorData[ALLOWED_FLAG_MESSAGES.DUPLICATE_TITLE_WITH_BAD_EXCEPTION]
    // because BE message would sometimes have extra words at the end of A page with this title already exists
    // eg com.atlassian.confluence.api.service.exceptions.api.BadRequestException: A page with this title already exists:
    // A page already exists with the title <PAGE_TITLE> in the space with key <SPACE_KEY>
    Object.keys(errorData)[0].indexOf((0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_TITLE_WITH_BAD_EXCEPTION) !== -1) return i18nFormatter.DUPLICATE_PAGE_TITLE(isUnpublishedDraft);
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).INVALID_PAGE_TITLE]) return i18nFormatter.INVALID_PAGE_TITLE_ERROR(isUnpublishedDraft);
    if (isTemplateEditor) return i18nFormatter.DEFAULT_TEMPLATE_SAVE_ERROR();
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).COLLAB_STATUS_ERROR]) return i18nFormatter.COLLAB_STATUS_ERROR();
    return i18nFormatter.DEFAULT_PUBLISH_ERROR(isUnpublishedDraft);
};
module.exports["buildEditorFlagMessage"] = $d33bb643a38eaa5e$export$cda5b5526dda47f7;

});


//# sourceMappingURL=NativeCollabComponent.92a72459.js.map
